var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09861 4.01339C4.69762 4.39316 4.68043 5.02609 5.0602 5.42708L6.83637 7.30248C4.41526 8.6224 2.91588 10.6213 2.22667 11.7156C1.92444 12.1966 1.92444 12.8033 2.22667 13.28C3.31556 15.0133 6.43111 19 12 19C13.8908 19 15.4988 18.5404 16.8406 17.8656L18.813 19.9481C19.1927 20.3491 19.8257 20.3663 20.2267 19.9866C20.6277 19.6068 20.6448 18.9739 20.2651 18.5729L6.5123 4.0518C6.13253 3.65082 5.4996 3.63362 5.09861 4.01339ZM13.7601 14.613L9.98571 10.6278C9.5292 11.1187 9.25 11.7767 9.25 12.5C9.25 14.0188 10.4812 15.25 12 15.25C12.6695 15.25 13.2832 15.0107 13.7601 14.613ZM20.0233 15.5037C20.8365 14.6677 21.4148 13.8536 21.7733 13.2843C22.0756 12.8033 22.0756 12.1966 21.7733 11.72C20.6889 9.98664 17.5733 5.99997 12 5.99997C11.6782 5.99997 11.3645 6.01327 11.059 6.03865L20.0233 15.5037Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.7897596f0d61c356837da90ba639e88d.svg";
export { ForwardRef as ReactComponent };